/**
 * @fileoverview 播放flash
 * @author zhenn
 */

define(function(require, exports, module) {
    var Base = require("c-base");

    var Flv = Base.extend({
        defaults: {
            wrap: "#wrap",
            source: {
                flv: "http://flv-player.net/medias/KyodaiNoGilga.flv",
            },
            sourceType: {
                flv: "video/flv",
                hls: "application/x-mpegURL"
            },
            id: 'video1',
            controls: true,
            isLandscape: false,
            videoLoad: function() {

            }
        },
        
        _compareVersion: function(a, b) {
            var aPart, aParts, bPart, bParts, i, len;
            if (a === b) {
                return 0;
            }
            aParts = (a + '').split('.');
            bParts = (b + '').split('.');
            for (i = 0, len = Math.max(aParts.length, bParts.length); i < len; ++i) {
                aPart = parseInt(aParts[i], 10);
                bPart = parseInt(bParts[i], 10);
                isNaN(aPart) && (aPart = 0);
                isNaN(bPart) && (bPart = 0);
                if (aPart < bPart) {
                    return -1;
                }
                if (aPart > bPart) {
                    return 1;
                }
            }
            return 0;
        },

        initialize: function() {
            let userAgent = window.navigator.userAgent;
            let isSafariShowHls = true;
            
            if (userAgent.indexOf('Safari') > -1) {
                let s = userAgent.match(/version\/([\d.]+).*safari/i);
                let safariVersion = '9.1.2';
                if (s != null && (typeof s === 'object')) {

                    safariVersion = s[1];
                }
                if (this._compareVersion(safariVersion, '10.1') > 0) {
                    isSafariShowHls = false;
                }
            }

            var self = this,
                wrap = $(self.get('wrap')),
                videoSourceArrHLS = [
                    '<video id="' + this.get('id') + '" width="0" height="0" autoplay>',
                    '<source type="video/x-mpegURL" data-type="hls">',
                    '<source type="application/x-shockwave-flash" data-type="flv">',
                    '</video>'
                ],
                videoSourceArrFLV = [
                    '<video id="' + this.get('id') + '" width="0" height="0" autoplay>',
                    '<source type="application/x-shockwave-flash" data-type="flv">',
                    '</video>'
                ],
                ch = self.ch = document.documentElement.clientHeight,
                cw = self.cw = document.body.clientWidth;
            
            let source = self.get('source');
            let sourceType = self.get('sourceType');

            if (isSafariShowHls && source.hls) {
                videoSourceArr = videoSourceArrHLS;
            } else {
                videoSourceArr = videoSourceArrFLV;
            }

            let element = $(videoSourceArr.join(''));
            
            wrap.append(element);
            
            $.map(source, function(item, key) {
                let _source = sourceType[key];

                if (key == 'flv') {
                    item = item.replace('http://wsflv.upliveapp.com', 'https://wsflv.upliveapp.com');
                } else if (key == 'hls') {
                    item = item.replace('http://wshls.upliveapp.com', 'https://wshls.upliveapp.com');
                }

                if (_source) {
                    element.find('[data-type="' + key + '"]').attr('src', item).attr('type', _source);
                }
            });
            // element.find('[data-type="hls"]').attr('src', self.get('source')).attr('type', 'application/x-mpegURL');
            // element.find('[data-type="flv"]').attr('src', self.get('source')).attr('type', 'video/flv');
        },

        play: function(wrap, source) {
            var self = this;
            var height = '100%';
            let isLandscape = self.get('isLandscape');
            // if ($('#videoWrap').length > 0) {
            //     height = $('#videoWrap').height() - 2;
            // } else if ($('.J_VideoWrap').length > 0) {
            //     height = $('.J_VideoWrap').height() - 2;
            // }

            var controls = self.get('controls');
            
            var flv = this.flv = VideoJS(this.get('id'), {
                techOrder: ["html5", "flash"],
                autoplay: true,
                controls: controls,
                poster: 'https://g.cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png',
                controlBar: {
                    captionsButton: false,
                    chaptersButton: false,
                    liveDisplay: false,
                    playbackRateMenuButton: false,
                    subtitlesButton: false
                }

            });

            flv.ready(function() {
                // 默认音量，全局控制
                this.volume(typeof window.videoJSLastVolume !== 'undefined' ? window.videoJSLastVolume : 0.7);

                this.one("loadeddata", function() {


                    self.viewsizeTimer && clearTimeout(self.viewsizeTimer);
                    self.viewsizeTimer = setTimeout(() => {
                        $(this.el).addClass("video-js vjs-default-skin").css({
                            width: '100%',
                            height: '100%',
                            // '-webkit-transform': 'scale(1.03)'
                        });

                        clearTimeout(self.viewsizeTimer);
                        if (!isLandscape) {
                            var i = 99.8;
                            var timer, timer1;

                            var changeWidth = () => {
                                if (i >= 100.3) {
                                    timer && clearTimeout(timer);
                                    return;
                                }
                                i += 0.01;

                                $(this.el).css({
                                    height: i + '%'
                                });

                                timer = setTimeout(function() {
                                    changeWidth();
                                }, 100);
                            };

                            changeWidth();

                            timer1 = setTimeout(() => {
                                i = 99.8;
                                timer1 && clearTimeout(timer1);
                                changeWidth();
                            }, 2000);
                        }

                    }, 1.5 * 1000)

                    self.emit("start");
                    self.emit("loadeddata");

                });
                var videoload = self.get('videoLoad');
                videoload.call(this, self.flv);

                this.one("ended", function() {
                    self.emit("ended");
                });
            });
            let wrapCss;
            if (isLandscape) {

                wrapCss = {
                    width: '100%',
                    height: '100%',
                };
            } else {
                wrapCss = {
                    width: '100%',
                    height: '100%',
                    '-webkit-transform': 'scale(1.03)'
                };
            }
            $("#" + this.get('id')).addClass("video-js vjs-default-skin").css(wrapCss);
            // flv.width(480);
            // flv.height(813);

        },

        showControlBar: function() {
            if (this.flv) {
                this.flv.controlBar.fadeIn();
            }
        },

        hideControlBar: function() {
            if (this.flv) {
                this.flv.controlBar.fadeOut();
            }
        },
        fullScreen: function() {
            if (this.flv) {
                this.flv.requestFullScreen();
            }
        },
        playToggle: function() {
            if (this.flv) {
                if (this.flv.paused()) {
                    this.flv.play()
                } else {
                    this.flv.pause()
                }
            }
        },
        volumeToggle: function(isMute) {
            if (this.flv) {
                if (isMute) {

                    this.volumeLevel = this.flv.volume();
                    this.flv.muted(true);
                    this.flv.volume(0);
                    window.videoJSLastVolume = 0;

                } else {
                    let lastVolume = this.volumeLevel || this.flv.volume();
                    this.flv.muted(false);
                    this.flv.volume(lastVolume);
                    window.videoJSLastVolume = this.volumeLevel;
                }
            }
        },
        volumeLevel: function() {
            if (!this.flv) {
                return;
            }
            var vol = this.flv.volume();
            var level = 0;

            if (vol == 0 || this.flv.muted()) {
                level = 0
            } else {

                level = vol;
            }
            return level;
        },
        volumeChange: function(volumeLevel) {
            window.videoJSLastVolume = volumeLevel;
            this.volumeLevel = volumeLevel;
            this.flv.volume(volumeLevel);
        },
        refresh: function(src) {
            if (this.flv) {
                if (!src) {
                    src = this.flv.currentSrc();
                }
                this.flv.src(src);
                this.flv.load();
                this.flv.play();
            }
        },

        destroy: function() {
            try {
                this.flv.destroy();
            } catch (e) {
                console.log(e.message);
            }
        }
    });

    if (typeof VideoJS !== 'undefined') {
        VideoJS.options.flash.swf = "//h.cdn.pengpengla.com/up/uplive-pc/1.0.9/assets/video-js.swf";
    }

    module.exports = Flv;
});


// WEBPACK FOOTER //
// ./js/component/video/flv.js